import type { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import { useCompanySettings } from 'src/hooks/use-company-settings';

interface SeoProps {
  title?: string;
  description?: string;
  canonicalUrl?: string;
  keywords?: string;
}

export const Seo: FC<SeoProps> = (props) => {
  const { title, description, canonicalUrl, keywords } = props;
  const { settings: company } = useCompanySettings();

  const companyName = company.companyName || 'Mystic Media Film';
  const companyTagline = company.tagline || 'Houston Video Production & Marketing';

  const fullTitle = title
    ? title
    : `${companyName} | ${companyTagline}`;

  const defaultDescription = `${companyName} is a Houston video production, web design, and digital marketing agency. We help ambitious brands grow with cinematic content and high-converting sites.`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description"
content={description || defaultDescription} />
      {keywords && <meta name="keywords"
content={keywords} />}
      {canonicalUrl && <link rel="canonical"
href={canonicalUrl} />}
      <meta property="og:title"
content={fullTitle} />
      <meta property="og:description"
content={description || defaultDescription} />
      <meta property="og:type"
content="website" />
      <meta property="twitter:title"
content={fullTitle} />
      <meta property="twitter:description"
content={description || defaultDescription} />
    </Helmet>
  );
};

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  canonicalUrl: PropTypes.string,
  keywords: PropTypes.string
};
